module.exports = __webpack_public_path__ + "img/servicio-al-cliente.863e68df.png";